<template>
  <div>
    <div :id="'preview' + preview.facebook_preview_id">
      <div v-html="preview.facebook_preview_ads_body"></div>
    </div>
    <div class="ad-data-copy">
      <div class="data">
        <h5>{{ Number(preview.reach || 0).toLocaleString() }}</h5>
        <p>Alcance</p>
      </div>
      <div class="data">
        <h5>{{ Number(preview.impressions || 0).toLocaleString() }}</h5>
        <p>Impresiones</p>
      </div>
      <div class="data">
        <h5>{{ Number(preview.clicks || 0).toLocaleString() }}</h5>
        <p>Clicks</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "iframe-custom",
  props: {
    preview: Object
  },
  data() {
    return {
      metrics: {}
    };
  },
  mounted() {
    let iframes =
      document.querySelectorAll(
        "#preview" + this.preview.facebook_preview_id + " iframe"
      )[0] || null;
    if (iframes) {
      iframes.width = 350 + "px";
      iframes.height = 340 + "px";
    }
  },
  created() {}
};
</script>
<style lang="scss" scoped>
.ad-data-copy {
  display: flex;
  justify-content: space-evenly;
  align-content: center;
  margin-top: 15px;
  flex-direction: column;
  .data {
    margin-bottom: 10px;
    text-align: center;
    &:last-child {
      border-right: 0px;
    }
    h5 {
      color: $highlight-color;
    }
  }
}

@include respond-above(sm) {
  .ad-data-copy {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    .data {
      border-right: 1px solid #f1f2f3;
      padding: 0px 20px;
      padding-top: 10px;
      padding-bottom: 10px;
      text-align: center;
      &:last-child {
        border-right: 0px;
      }
    }
  }
}
</style>
